import React from 'react'
import styled, {css} from 'styled-components'
import i1 from '../../assets/img/1.png'
import i2 from '../../assets/img/2.png'
import i3 from '../../assets/img/3.png'
import i4 from '../../assets/img/4.png'
import Logo from "../Logo";
import {Animated} from "react-native";

const Footer: React.FC = () => (
    <StyledFooter>
        <StyledFooterInner>
            <Logo/>

            <RightWap>
                <RightWidget>
                    <StyleImages>
                        <li>

                            <a href="https://twitter.com/Nsure_network" target="_blank" rel=""> <img src={i1} width="16"
                                                                                                     alt=""/></a>
                        </li>
                        <li>

                            <a href="https://discord.com/invite/nSvAapa" target="_blank" rel=""><img src={i2} width="16"
                                                                                                     alt=""/></a>
                        </li>
                        <li>

                            <a href="https://t.me/nsurenet" target="_blank" rel=""> <img src={i3} width="16"
                                                                                         alt=""/></a>
                        </li>
                        <li>

                            <a href="https://nsure-network.medium.com/" target="_blank" rel=""> <img src={i4} width="16"
                                                                                                     alt=""/></a>
                        </li>
                    </StyleImages>
                </RightWidget>
                <RightWidget>
                    <p>contact@Nsure.network</p>
                </RightWidget>
            </RightWap>
        </StyledFooterInner>
    </StyledFooter>
);

const RightWidget: React.FC = ({children}) => {
    return (<StyleRight>
        <h2>SOCIAL</h2>
        {children}
    </StyleRight>);
};

const RightWap = styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
@media (max-width: 768px) {
  justify-content: space-between;
  }
 
`;
const StyleRight = styled.div`
 width: 200px;
 margin-left: 100px;
 @media (max-width: 768px) {
  margin-left: 0;
  margin-top:  20px;
  width: 150px;
  }
 


h2{
    font-size: 16px;
    font-weight: 400;
    color: ${(props) => props.theme.color.whites[1001]};
    margin-bottom: 20px;
}
p{
    font-size: 16px;
    font-weight: 400;
    color: ${(props) => props.theme.color.whites[100]};
  &:hover{
     color: ${(props) => props.theme.color.whites[1001]};

  }

}
`;

const StyleImages = styled.ul`
display: flex;
justify-content: space-between;
li{
  a{
  img{
  display: block;
  opacity: .6;
  width: 20px;
  &:hover{
  opacity: 1;
  }
  }
  }
}
`;


const StyledFooter = styled.footer`
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: rgba(3, 11, 29, 1);
  padding: 20px 0;
  box-sizing: border-box;
`;
const StyledFooterInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: ${props => props.theme.siteWidth}px;
  //width: 100%;
  width: 1000px;
  
  ${(ev) => mxmin}
  
`;

const mxmin = css`
 @media (max-width: 768px) {
   flex-flow: column;
  }
`;

export default Footer
